import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    loading: string;
    errorMessage: string;
    successMessage: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Toast message while creating project */
            loading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseCreateProjectFromTemplate.loading?c=26xmcdnqk3a3z", defaultMessage: "Creating Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when project creation fails */
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseCreateProjectFromTemplate.errorMessage?c=37ommcrrhrf24", defaultMessage: "Couldn''t create Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Toast message when project is successfully created */
            successMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "Shared_UseCreateProjectFromTemplate.successMessage?c=29i9nttymy7iw", defaultMessage: "Project created" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
